import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="share"
export default class extends Controller {
  static values = {
    url: String,
    title: String,
    text: String,
  };

  async invoke(event) {
    // Safe event handling
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // 1. Hotwire Native Android Check
    if (
      window.AndroidShareBridge &&
      typeof window.AndroidShareBridge.share === "function"
    ) {
      window.AndroidShareBridge.share(
        this.titleValue,
        this.textValue,
        this.urlValue,
      );
      return;
    }

    // 2. Native Web Share API (iOS Safari, Chrome on Android browsers)
    if (navigator.share) {
      try {
        await navigator.share({
          title: this.titleValue,
          text: this.textValue,
          url: this.urlValue,
        });
      } catch (err) {
        console.log("User canceled the share.", err);
      }
      return;
    }

    // 3. Desktop / Legacy Fallback
    navigator.clipboard.writeText(this.urlValue);
    alert("Secure link copied to clipboard!");
  }
}
